export default __webpack_public_path__ + "static/media/TNG.4670f12a.svg";